// extracted by mini-css-extract-plugin
export default {"details":"styles_details__ZDyxA","item-name":"styles_item-name__NkSEN"};